export default __webpack_public_path__ + "static/media/search-image.b1939d0b.svg";